export function LoadingPage() {
  return (
    <main className="auth-page" aria-label="Loading">
      <section className="auth-action" aria-hidden="true">
        <div className="auth-progress" />
      </section>
    </main>
  );
}
